import React, { useMemo } from 'react';
import styled from 'styled-components';
import { ARTIFACT_SANDBOX, buildArtifactDocument } from './artifactDocument';

const Frame = styled.iframe`
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  background: #fff;
`;

interface Props {
  type: string;
  content: string;
  title: string;
}

/**
 * O artefato em si. sandbox sem allow-same-origin: o código roda numa origem
 * opaca, isolado da sessão do chat (não lê tokens, cookies nem chama a API
 * autenticada). Sem allow-top-navigation: não consegue redirecionar a página.
 */
const ArtifactFrame: React.FC<Props> = ({ type, content, title }) => {
  const doc = useMemo(() => buildArtifactDocument(type, content), [type, content]);
  return (
    <Frame
      title={title}
      sandbox={ARTIFACT_SANDBOX}
      srcDoc={doc}
      referrerPolicy="no-referrer"
      allow="fullscreen; clipboard-write"
    />
  );
};

export default ArtifactFrame;
